export const MENU_DUCK_DB = -12;
export const OPEN_CUTOFF_HZ = 20000;
